import { sizer } from "layout/styles/styled/sizer";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressBar } from "primereact/progressbar";
import { Timeline } from "primereact/timeline";
import styled from "styled-components";

interface IStyledPageContainerProps {
  maxWidth?: string;
  minWidth?: string;
}

export const PriceWrapper = styled.div`
  background: rgba(71, 105, 234, 0.05);
  border-radius: 0.5rem;
  padding: 0.625rem 1rem;
`;

export const StyledTimeline = styled(Timeline)`
  font-size: 14px !important;
  max-height: 250px;
  overflow-y: auto;
  .p-timeline-event-opposite {
    display: none;
  }
  .p-timeline-event-content {
    padding-top: 0px !important;
    padding-right: 0px !important;
  }
  .p-timeline-event {
    min-height: 50px;
  }
  .p-timeline-event-connector {
    background-color: #e2e2e4;
  }
  .p-timeline-event-marker {
    border-color: #d0ccfe;
    background-color: transparent;
    width: 20px;
    height: 20px;
  }

  .p-timeline-event .p-active {
    border-color: #f6f8fe;
    box-shadow: 0px 4px 5px -1px rgba(0, 0, 0, 0.18);
    background-color: #584dfd;
    position: relative;
    border-width: 1.5px;
  }
  .p-timeline-event .p-active::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 7px;
    height: 7px;
    background-color: #f6f8fe;
    border-radius: 50%;
  }
`;

export const StyledBreadcrumbContainer = styled.div`
  display: flex;
  width: 100%;

  @media (min-width: 1024px) {
    padding-left: 96px !important;
    padding-right: 96px !important;
  }
`;

export const StyledBreadCrumb = styled(BreadCrumb)`
  border: none;
  padding: 0px;
  font-size: 14px;
  ul > li:first-child {
    display: none;
  }
  span {
    color: #706f7b !important;
  }
  .active {
    color: #4f46e5 !important;
  }
  button {
    color: #706f7b !important;
    font-size: 14px !important;
    padding: 0px !important;
  }
  button:hover {
    background-color: transparent !important;
  }

  /* Hide the default chevron */
  .p-breadcrumb-chevron::before {
    content: "/";
    font-family: inherit;
    font-size: 1rem;
    color: #706f7b;
  }
  .p-button: focus {
    box-shadow: none !important;
  }
`;

export const StyledPageContainer = styled.div<IStyledPageContainerProps>`
  max-width: ${({ maxWidth }) => maxWidth || "690px"};
  min-width: ${({ minWidth }) => minWidth || "690px"};
  display: flex;
  flex-direction: column;
  padding-left: 16px;
  padding-right: 16px;
  margin-top: 48px;

  p {
    color: #667085;
  }
  .purple {
    color: #4f46e5;
  }
  .green {
    color: #027a48;
  }
  .light-green {
    color: #07a685;
  }
  .red {
    color: #d92d20;
  }
  .highlighted {
    color: #17143f;
  }
  .black {
    color: #17143f;
  }
  .gray {
    color: #706f7b;
  }
  @media (max-width: 672px) {
    min-width: 100%;
    width: 100%;
    margin-top: 20px;
  }
`;

export const StyledSectionContainer = styled.div`
  border: 1px solid #e2e2e4;
  border-radius: 12px;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  gap: 16px;
  .gray {
    color: #858490;
  }
  .shadow {
    box-shadow: 0px 5px 10px 0px rgba(18, 12, 96, 0.06),
      0px 2px 2px 0px rgba(17, 12, 96, 0.1);
  }
`;

export const StyledPriceContainer = styled.div`
  background: #f6f8fe;
  border-radius: 12px;
  padding: 20px 16px;
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  gap: 30px;
  @media (max-width: 640px) {
    gap: 25px;
  }
`;

export const HorizontalLine = styled.hr`
  border-top: 1px solid #e2e2e4;
`;

export const ContainerForm = styled.form`
  max-width: 522px;
  display: flex;
  flex-direction: column;
  .title {
    font-size: 30px;
    line-height: 36px;
    color: #4f46e5;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .warning {
    color: #f04438;
  }

  .gray {
    color: #858490;
  }

  p {
    text-align: center;
    margin-bottom: 8px;

    font-weight: 700;
    font-size: 24px;

    color: #5b4dfd;
  }
  img {
    height: 30px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 38px;
    @media (max-width: 720px) {
      top: 32px;
    }
  }
`;

export const StyledInfoContainer = styled.div`
  background-color: #f7f7f8;
`;

export const StyledProgressBar = styled(ProgressBar)<{ height?: number }>`
  border-radius: 16px;
  height: ${({ height }) => height ?? 10}px;
  .p-progressbar-value {
    background: #4f46e5;
  }
`;

export const StyledCardContainer = styled.div`
  padding: 20px;
  border: 1px solid #e2e2e4;
  border-radius: 12px;
  box-shadow: 1px 2px 2px 0px rgba(16, 24, 40, 0.05);
`;

export const StyledInputNumber = styled(InputNumber)`
  .p-inputtext {
    &::placeholder {
      color: #999;
      font-size: 14px;
    }
  }
`;

export const StyledInputTextarea = styled(InputTextarea)`
  &::placeholder {
    color: #999;
    font-size: 14px;
  }
`;

export const StyledButton = styled(Button)`
  gap: ${sizer(2)};
  margin-bottom: ${sizer(4)};
  margin-top: ${sizer(4)};
  margin-left: ${sizer(8)};
  align-self: start;

  span:first-child {
    font-size: ${sizer(3)};
  }
`;
